import { render } from "./PublicNavBar.vue?vue&type=template&id=04249a48"
const script = {}

import exportComponent from "/var/www/app.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__